import * as index from './components/index.es.js';
export { index as DSIcons };
export { hasColoredIcon } from './helpers/index.es.js';
export { AccountColored } from './components/AccountColored.es.js';
export { AccountFilled } from './components/AccountFilled.es.js';
export { AccountOutlined } from './components/AccountOutlined.es.js';
export { AddAlternativeOutlined } from './components/AddAlternativeOutlined.es.js';
export { AddOutlined } from './components/AddOutlined.es.js';
export { AnonymousUserProfileOutlined } from './components/AnonymousUserProfileOutlined.es.js';
export { ArrowDownFilled } from './components/ArrowDownFilled.es.js';
export { ArrowDownTinyFilled } from './components/ArrowDownTinyFilled.es.js';
export { ArrowUpFilled } from './components/ArrowUpFilled.es.js';
export { ArrowUpTinyFilled } from './components/ArrowUpTinyFilled.es.js';
export { BackOutlined } from './components/BackOutlined.es.js';
export { BackToTopOutlined } from './components/BackToTopOutlined.es.js';
export { BellOutlined } from './components/BellOutlined.es.js';
export { BoxOutlined } from './components/BoxOutlined.es.js';
export { BriefCaseOutlined } from './components/BriefCaseOutlined.es.js';
export { BuildPcOutlined } from './components/BuildPcOutlined.es.js';
export { BulletedListOutlined } from './components/BulletedListOutlined.es.js';
export { BusinessCustomerOutlined } from './components/BusinessCustomerOutlined.es.js';
export { CalendarOutlined } from './components/CalendarOutlined.es.js';
export { CallFilled } from './components/CallFilled.es.js';
export { CartFilled } from './components/CartFilled.es.js';
export { CartOutlined } from './components/CartOutlined.es.js';
export { CashColored } from './components/CashColored.es.js';
export { CashOutlined } from './components/CashOutlined.es.js';
export { CautionOutlined } from './components/CautionOutlined.es.js';
export { CheckOutlined } from './components/CheckOutlined.es.js';
export { ChecklistOutlined } from './components/ChecklistOutlined.es.js';
export { ChevronDownOutlined } from './components/ChevronDownOutlined.es.js';
export { ChevronForwardFilled } from './components/ChevronForwardFilled.es.js';
export { ChevronLeftFilled } from './components/ChevronLeftFilled.es.js';
export { ChevronUpFilled } from './components/ChevronUpFilled.es.js';
export { ChevronUpOutlined } from './components/ChevronUpOutlined.es.js';
export { ClockAlternativeOutlined } from './components/ClockAlternativeOutlined.es.js';
export { ClockFilled } from './components/ClockFilled.es.js';
export { CloseOutlined } from './components/CloseOutlined.es.js';
export { CopyOutlined } from './components/CopyOutlined.es.js';
export { CopyrightColored } from './components/CopyrightColored.es.js';
export { CubeOutlined } from './components/CubeOutlined.es.js';
export { DeleteCircleColored } from './components/DeleteCircleColored.es.js';
export { DeleteCircleFilled } from './components/DeleteCircleFilled.es.js';
export { DinoOutlined } from './components/DinoOutlined.es.js';
export { DiscountColored } from './components/DiscountColored.es.js';
export { DiscountFilled } from './components/DiscountFilled.es.js';
export { DiscountOutlined } from './components/DiscountOutlined.es.js';
export { DiscountTagColored } from './components/DiscountTagColored.es.js';
export { DiscountTagFilled } from './components/DiscountTagFilled.es.js';
export { DiscountTagOutlined } from './components/DiscountTagOutlined.es.js';
export { DocumentOutlined } from './components/DocumentOutlined.es.js';
export { DotOutlined } from './components/DotOutlined.es.js';
export { DownOutlined } from './components/DownOutlined.es.js';
export { DownloadOutlined } from './components/DownloadOutlined.es.js';
export { DragdropOutlined } from './components/DragdropOutlined.es.js';
export { DuplicateOutlined } from './components/DuplicateOutlined.es.js';
export { EditOutlined } from './components/EditOutlined.es.js';
export { EmptySearchColored } from './components/EmptySearchColored.es.js';
export { ExportFileOutlined } from './components/ExportFileOutlined.es.js';
export { ExportStockOutlined } from './components/ExportStockOutlined.es.js';
export { EyeHideFilled } from './components/EyeHideFilled.es.js';
export { EyeShowFilled } from './components/EyeShowFilled.es.js';
export { FacebookFilled } from './components/FacebookFilled.es.js';
export { FacebookMessengerFilled } from './components/FacebookMessengerFilled.es.js';
export { FacebookSquareFilled } from './components/FacebookSquareFilled.es.js';
export { FavouriteAlternativeOutlined } from './components/FavouriteAlternativeOutlined.es.js';
export { FavouriteFilled } from './components/FavouriteFilled.es.js';
export { FileOutlined } from './components/FileOutlined.es.js';
export { FireFlashsaleColored } from './components/FireFlashsaleColored.es.js';
export { FlashSaleFilled } from './components/FlashSaleFilled.es.js';
export { ForwardOutlined } from './components/ForwardOutlined.es.js';
export { FreeShippingColored } from './components/FreeShippingColored.es.js';
export { GarbageFilled } from './components/GarbageFilled.es.js';
export { GiftColored } from './components/GiftColored.es.js';
export { GiftFilled } from './components/GiftFilled.es.js';
export { GlobalFilled } from './components/GlobalFilled.es.js';
export { GoogleFilled } from './components/GoogleFilled.es.js';
export { GreenGiffColored } from './components/GreenGiffColored.es.js';
export { HamburgerOutlined } from './components/HamburgerOutlined.es.js';
export { HeadphoneOutlined } from './components/HeadphoneOutlined.es.js';
export { HeartOutlined } from './components/HeartOutlined.es.js';
export { HighlightBackgroundFilled } from './components/HighlightBackgroundFilled.es.js';
export { HomeLocationColored } from './components/HomeLocationColored.es.js';
export { HomeLocationOutlined } from './components/HomeLocationOutlined.es.js';
export { HomePageOutlined } from './components/HomePageOutlined.es.js';
export { HomepageAlternativeOutlined } from './components/HomepageAlternativeOutlined.es.js';
export { HomepageFilled } from './components/HomepageFilled.es.js';
export { InboxOutlined } from './components/InboxOutlined.es.js';
export { InforFilled } from './components/InforFilled.es.js';
export { InforOutlined } from './components/InforOutlined.es.js';
export { JumpBackOutlined } from './components/JumpBackOutlined.es.js';
export { JumpForwardOutlined } from './components/JumpForwardOutlined.es.js';
export { LeftOutlined } from './components/LeftOutlined.es.js';
export { LinkOutlined } from './components/LinkOutlined.es.js';
export { LocationColored } from './components/LocationColored.es.js';
export { LocationOutlined } from './components/LocationOutlined.es.js';
export { LocationPickerColored } from './components/LocationPickerColored.es.js';
export { LogOutOutlined } from './components/LogOutOutlined.es.js';
export { MailOutlined } from './components/MailOutlined.es.js';
export { MarkAsReadAlternativeOutlined } from './components/MarkAsReadAlternativeOutlined.es.js';
export { MenuOutlined } from './components/MenuOutlined.es.js';
export { MessengerColored } from './components/MessengerColored.es.js';
export { MinusOutlined } from './components/MinusOutlined.es.js';
export { MonitorOutlined } from './components/MonitorOutlined.es.js';
export { MoreInforOutlined } from './components/MoreInforOutlined.es.js';
export { MoreProductOutlined } from './components/MoreProductOutlined.es.js';
export { NavigationOutlined } from './components/NavigationOutlined.es.js';
export { NewBellOutlined } from './components/NewBellOutlined.es.js';
export { NewLayoutShoppingCartOutlined } from './components/NewLayoutShoppingCartOutlined.es.js';
export { NewMoneyColored } from './components/NewMoneyColored.es.js';
export { NewMoreProductOutlined } from './components/NewMoreProductOutlined.es.js';
export { NewSearchOutlined } from './components/NewSearchOutlined.es.js';
export { NewVoucherColored } from './components/NewVoucherColored.es.js';
export { NewsOutlined } from './components/NewsOutlined.es.js';
export { NotificationsOutlined } from './components/NotificationsOutlined.es.js';
export { OrderFilled } from './components/OrderFilled.es.js';
export { OrderOutlined } from './components/OrderOutlined.es.js';
export { PackagedHamperOutlined } from './components/PackagedHamperOutlined.es.js';
export { PaymentOutlined } from './components/PaymentOutlined.es.js';
export { PbNavigationRoundFilled } from './components/PbNavigationRoundFilled.es.js';
export { PenColored } from './components/PenColored.es.js';
export { PencilOutlined } from './components/PencilOutlined.es.js';
export { PhoneCallColored } from './components/PhoneCallColored.es.js';
export { PhoneOutlined } from './components/PhoneOutlined.es.js';
export { PlayOutlined } from './components/PlayOutlined.es.js';
export { PrinterOutlined } from './components/PrinterOutlined.es.js';
export { ProfileFilled } from './components/ProfileFilled.es.js';
export { ProfileOutlined } from './components/ProfileOutlined.es.js';
export { PromoOutlined } from './components/PromoOutlined.es.js';
export { QaOutlined } from './components/QaOutlined.es.js';
export { QrCodeColored } from './components/QrCodeColored.es.js';
export { RatingAlternativeOutlined } from './components/RatingAlternativeOutlined.es.js';
export { RatingFilled } from './components/RatingFilled.es.js';
export { RefreshOutlined } from './components/RefreshOutlined.es.js';
export { RewardBronzeCircleColored } from './components/RewardBronzeCircleColored.es.js';
export { RewardGoldenCircleColored } from './components/RewardGoldenCircleColored.es.js';
export { RewardPlatinumCircleColored } from './components/RewardPlatinumCircleColored.es.js';
export { RewardSilverCircleColored } from './components/RewardSilverCircleColored.es.js';
export { RightOutlined } from './components/RightOutlined.es.js';
export { SaveOutlined } from './components/SaveOutlined.es.js';
export { ScanningOutlined } from './components/ScanningOutlined.es.js';
export { SearchOutlined } from './components/SearchOutlined.es.js';
export { SettingAlternativeOutlined } from './components/SettingAlternativeOutlined.es.js';
export { ShareFilled } from './components/ShareFilled.es.js';
export { ShieldOutlined } from './components/ShieldOutlined.es.js';
export { ShippingOutlined } from './components/ShippingOutlined.es.js';
export { ShopColored } from './components/ShopColored.es.js';
export { ShopOutlined } from './components/ShopOutlined.es.js';
export { ShoppingCartAddColored } from './components/ShoppingCartAddColored.es.js';
export { ShoppingCartColored } from './components/ShoppingCartColored.es.js';
export { ShoppingCartFilled } from './components/ShoppingCartFilled.es.js';
export { ShoppingCartOutlined } from './components/ShoppingCartOutlined.es.js';
export { ShortingOutlined } from './components/ShortingOutlined.es.js';
export { ShowroomOutlined } from './components/ShowroomOutlined.es.js';
export { StyledSearchOutlined } from './components/StyledSearchOutlined.es.js';
export { SuccessColored } from './components/SuccessColored.es.js';
export { TickFilled } from './components/TickFilled.es.js';
export { TimeForwardOutlined } from './components/TimeForwardOutlined.es.js';
export { TrashBinDeleteRemoveOutlined } from './components/TrashBinDeleteRemoveOutlined.es.js';
export { TvNewOutlined } from './components/TvNewOutlined.es.js';
export { TwoLinesTrashbinDeleteOutlined } from './components/TwoLinesTrashbinDeleteOutlined.es.js';
export { UnionOutlined } from './components/UnionOutlined.es.js';
export { UnionPaymentOutlined } from './components/UnionPaymentOutlined.es.js';
export { UpOutlined } from './components/UpOutlined.es.js';
export { UploadOutlined } from './components/UploadOutlined.es.js';
export { UsaColored } from './components/UsaColored.es.js';
export { UserProfileColored } from './components/UserProfileColored.es.js';
export { UserProfileFilled } from './components/UserProfileFilled.es.js';
export { VietnamColored } from './components/VietnamColored.es.js';
export { VoucherColored } from './components/VoucherColored.es.js';
export { VoucherFilled } from './components/VoucherFilled.es.js';
export { VoucherTagColored } from './components/VoucherTagColored.es.js';
export { WarningOutlined } from './components/WarningOutlined.es.js';
export { ZaloFilled } from './components/ZaloFilled.es.js';
export { GenIcon, IconBase, SvgCss } from './helpers/IconBase.es.js';
export { DefaultContext, IconContext } from './helpers/IconContext.es.js';
